import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import SatelliteTracker from '../components/space/SatelliteTracker';

export default function SatelliteTrackerPage() {
  const [userLocation, setUserLocation] = useState(null);

  useEffect(() => {
    navigator.geolocation?.getCurrentPosition(
      p => setUserLocation({ lat: p.coords.latitude, lon: p.coords.longitude })
    );
  }, []);

  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" sx={{ fontWeight: 800 }}>
          🛰️ Satellite Tracker
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
          Real-time satellite positions on interactive world map
        </Typography>
      </Box>
      <SatelliteTracker userLocation={userLocation} />
    </Box>
  );
}